module.exports = __webpack_public_path__ + "static/media/SLICA-removebg-preview.db282310.png";